import { registerBlockType } from "@wordpress/blocks";
import React from "react";
import config from "./block.json";
import { InnerBlocks } from "@wordpress/block-editor";
import { useBlockProps, useInnerBlocksProps } from "@wordpress/block-editor";

const ALLOWED_BLOCKS = [
  "yellowtree/card",
  "yellowtree/news-card",
  "yellowtree/row",
];

function MobileSliderEditor() {
  const innerBlocksProps = useInnerBlocksProps(
    useBlockProps({
      className: "grid-container",
    }) as unknown as Record<string, unknown>,
    {
      allowedBlocks: ALLOWED_BLOCKS,
    }
  );

  return <div {...innerBlocksProps} />;
}

registerBlockType(config.name, {
  ...config,
  attributes: {},

  edit: MobileSliderEditor,

  save(props) {
    return (
      <div
        {...useBlockProps.save({
          className: "swiper-wrapper grid-container",
        })}
      >
        <InnerBlocks.Content />
      </div>
    );
  },
});
